import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FAQSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <RankingSection />
        <IndexSection />
        <CommentsSection />
        <AboutSection />
        <CardsSection />
        <CarouselSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}